export default "__VITE_ASSET__BACrhPSc__"